/**
 * SSO Plugin that synchronizes the access and refresh token using the Shared Storage Library
 */
// import store from '@/store';
// import router from '@/router';
import sharedStorage from './sharedStorage/client';

// Import type definitions
/** @typedef {import('./sharedStorage/types').PostRobotHandlerParams} PostRobotHandlerParams */
/**
 * @typedef {import('./sharedStorage/types').SharedStorageUpdateResponse}SharedStorageUpdateResponse
 */
/** @typedef {import('./types').AuthPayload} AuthPayload */

/** Whether this lib is ready to be used or not */
let Initialized = false;

/**
 * Verify if the user has access to this application and load the auth data from sharedStorage
 * @param {AuthPayload} authData the auth data stored in the sharedStorage
 * @returns whether the authData was loaded or not
 */
function setLocalAuthData() {
  // We don't need this for the time being

  return false;
}

/**
 * Handle any change on the sharedStorage, which include the user logging out or in, a new user
 * logging in or simple changes to the data, like access token updates.
 * @param {PostRobotHandlerParams} postRobotHandlerParams object sent by postRobot on its messages.
 *        Contains the storage in data
 */
async function handleStorageUpdate() {
  // We don't need to listen to this for the time being
}

/**
 * Update the auth data stored in the sharedStorage
 * @param {AuthPayload} authData the data to write to the sharedStorage under the auth key
 * @return a string if the operation was successful
 */
async function updateAuthData(authData) {
  if (Initialized) {
    return sharedStorage.request('post', {
      key: 'auth',
      value: JSON.stringify(authData),
    });
  }

  // Using Promise.resolve to not throw any errors
  return Promise.resolve('SSO not initiallized');
}

/**
 * Fetch the auth data in the sharedStorage
 * @returns the data as an JSOM object
 */
async function requestAuthData() {
  if (Initialized) {
    const auth = await sharedStorage.request('get', { key: 'auth' });
    return JSON.parse(auth);
  }

  return Promise.reject(new Error('SSO not initialized'));
}

/**
 * Reset all the data under the auth key to the default (null) values
 * @return a string if the operation was successful
 */
async function clearAuthData() {
  if (Initialized) {
    const emptyData = {
      access_token: null,
      applications: [],
      first_name: null,
      isAuthenticated: false,
      last_name: null,
      refresh_token: null,
      user_id: null,
    };

    return sharedStorage.request('post', {
      key: 'auth',
      value: JSON.stringify(emptyData),
    });
  }

  // Using Promise.resolve to not throw any errors
  return Promise.resolve('SSO not initiallized');
}

/**
 * Initialize the sharedStorage library (load the iframe) and try to load the data that's
 * currently in the sharedStorage
 */
export default async function init() {
  // Check if we have the url in the environment variables
  if (process.env.SHARED_STORAGE_URL) {
    // Initialize the shared storage
    await sharedStorage.init(process.env.SHARED_STORAGE_URL, handleStorageUpdate);
    Initialized = true;

    // Get the auth data from the shared storage and set it
    // const auth = await requestAuthData();
    // if (auth !== null) setLocalAuthData(auth);
  }
}

export {
  updateAuthData,
  requestAuthData,
  clearAuthData,
  setLocalAuthData,
};
